import { render, staticRenderFns } from "./SquareResultModal.vue?vue&type=template&id=8cdf946e&scoped=true&"
import script from "./SquareResultModal.vue?vue&type=script&lang=js&"
export * from "./SquareResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdf946e",
  null
  
)

export default component.exports